<template>
  <van-swipe-cell
    class="message-item-wrapper"
    :right-width="item.has_read ? 72 : 180"
    :left-width=0.1
    :on-close="onSwipeClose"
  >
    <div class="child-message-item">
      <div class="item-content has-border-bottom">
        <div class="thumb-icon">
          <svg-icon icon="msg-collab"/>
          <badge v-if="!item.has_read"/>
        </div>
        <div class="content">
          <div class="folder-name">{{item.item_name}}</div>
          <div class="time">{{updateTime}}</div>
          <div class="detail">{{detail}}</div>
          <div v-if="note" class="note">{{note}}</div>
        </div>
      </div>

      <div v-if="item.accepted" class="action" @click="viewTarget">
        <i class="iconfont icon-view"></i>
        <span>{{$t('message.child.viewFolder')}}</span>
      </div>
      <div v-else-if="item.item_typed_id" class="action" @click="acceptCollab">
        <i class="iconfont icon-join-collab"></i>
        <span>{{$t('message.child.acceptCollab')}}</span>
      </div>
      <div v-else class="action disabled">
        <i class="iconfont icon-prompt"></i>
        <span>{{$t('message.child.invitationInvalid')}}</span>
      </div>
    </div>
    <template slot="right">
      <div v-if="!item.has_read" class="mark-read" @click="recordActionName('mark')">{{$t('message.markAsRead')}}</div>
      <div class="delete" @click="recordActionName()">{{$t('base.delete')}}</div>
    </template>
  </van-swipe-cell>
</template>
<script>
import {formatDate, escapeHTML, alert, confirm} from '@/utils/common'
import ajax from '@/utils/ajax'
import {i18n} from '@/utils/i18n'
import Badge from '../utils/Badge'
import {GET_COLLAB, ACCEPT_COLLAB, CHILD_MESSAGES_MARK_READ, CHILD_MESSAGES_DELETE} from '@/config/api'

export default {
  name: 'ChildMessageItem',
  i18n,
  components: {
    Badge
  },
  props: {
    item: Object
  },
  data () {
    return {
      rigthAction: 'delete'
    }
  },
  computed: {
    updateTime () {
      return formatDate(this.item.updated * 1000)
    },
    detail () {
      let { sender_name, collab_type, group_name } = this.item
      let message_content = ''

      if (!collab_type) {
        message_content = i18n.t('message.child.inviteYouToCollab')
      } else if (collab_type === 'group') {
        message_content = i18n.t('message.child.inviteGroupToCollab', [escapeHTML(group_name)])
      } else if (collab_type === 'department') {
        message_content = i18n.t('message.child.inviteDeptToCollab', [escapeHTML(group_name)])
      }

      return sender_name + message_content
    },
    note () {
      if (!this.item.invitation_message) {
        return false
      }
      return escapeHTML(this.item.invitation_message)
    }
  },
  methods: {
    viewTarget () {
      this.markRead()
      const { collab_id, item_typed_id } = this.item
      const folder_id = item_typed_id.split('_')[1]
      ajax({
        url: `${GET_COLLAB}?collab_id=${collab_id}`,
        accept_errors: ['external_errors']
      }).then(res => {
        if (res.errors) {
          this.showInvitationInvalid()
        } else {
          this.$router.push(`/files/folder/${folder_id}?from_message=1`)
        }
      })
    },
    acceptCollab () {
      this.markRead()
      const { collab_id } = this.item
      confirm({
        className: 'dialog',
        message: i18n.t('message.child.acceptCollab.confirm'),
        confirmButtonText: i18n.t('message.child.acceptCollab'),
        cancelButtonText: i18n.t('base.cancelText')
      }).then(() => {
        ajax({
          url: ACCEPT_COLLAB,
          data: {collab_id},
          accept_errors: ['external_errors', 'permission_denied'],
          successMessage: i18n.t('message.child.acceptCollab.success')
        }).then(res => {
          const { errors } = res
          if (errors) {
            this.showInvitationInvalid()
          } else {
            this.item.accepted = true
          }
        })
      }).catch(() => {
        console.log('cancel')
      })
    },
    showInvitationInvalid () {
      alert({
        title: i18n.t('message.child.invitationInvalid'),
        message: i18n.t('message.child.contactInviter')
      })
    },
    recordActionName (actionName) {
      this.rigthAction = actionName || 'delete'
    },
    markRead () {
      return ajax({
        url: CHILD_MESSAGES_MARK_READ,
        type: 'POST',
        data: {
          child_message_ids: [this.item.id],
          type: 'collab'
        }
      }).then(res => {
        if (res && res.success) {
          this.item.has_read = 1
          this.setState({actionState: {
            action: 'markRead',
            id: this.$route.params.id
          }})
        }
        return res
      })
    },
    onSwipeClose (clickPosition, instance) {
      switch (clickPosition) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close()
          break
        case 'right':
          if (this.rigthAction === 'mark') {
            this.markRead().then(() => {
              instance.close()
            })
          } else {
            confirm({
              className: 'dialog danger-dialog',
              title: i18n.t('file.message.delete.confirm'),
              message: i18n.t('file.message.delete.confirm.sub'),
              confirmButtonText: i18n.t('base.delete'),
              cancelButtonText: i18n.t('base.cancelText')
            }).then(() => {
              this.markRead()
              ajax({
                url: CHILD_MESSAGES_DELETE,
                data: {
                  child_message_ids: [this.item.id],
                  type: 'collab'
                },
                successMessage: i18n.t('file.message.delete.success')
              }).then(res => {
                if (res && res.success) {
                  instance.close()
                  this.$emit('message-delete', this.item.id)
                }
              })
            }).catch(() => {}) // https://stackoverflow.com/questions/42460039/promise-reject-causes-uncaught-in-promise-warning
          }
          break
      }
    }
  }
}
</script>
<style lang="postcss">
.child-message-item {
  margin-bottom: 10px;
  background-color: #fff;

  & .item-content {
    display: flex;
    padding: 12px 15px 10px;
  }

  & .thumb-icon {
    position: relative;
    flex: 0 0 auto;
    width: 30px;
    margin-right: 10px;
    margin-top: 5px;

    & svg {
      width: 30px;
      height: 30px;
    }
  }

  & .folder-name {
    font-size: 16px;
    min-height: 22px;
    line-height: 22px;
  }

  & .time {
    font-size: 12px;
    color: #c1c1c1;
  }

  & .detail {
    margin-top: 10px;
    font-size: 14px;
    color: #4e5660;
  }

  & .note {
    padding: 10px;
    margin-top: 10px;
    background-color: #f6f7f9;
    color: #848484;
    font-size: 14px;
    line-height: 1.43;
  }

  & .action {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    text-align: center;
    font-size: 12px;

    &.disabled {
      color: #d1d4e0
    }

    &>* {
      display: inline-block;
      vertical-align: middle
    }

    & i {
      color: #9198b2;
    }

    & .icon-prompt {
      font-size: 14px;
      color: #d1d4e0
    }
  }
}
</style>
